export class SetUsername {
    static readonly type = "[APP] Set Username";
    constructor(public payload: string) {}
}
